






















import Vue from 'vue';
import axios from 'axios';
import { defineComponent } from '@vue/composition-api';
import { accessor } from '../store';

export default defineComponent({
  data() {
    return {
      message: '',
      isLoading: false
    };
  },
  computed: {
    reservedNum: {
      get() {
        return accessor.changeInfo.reservedNum;
      },
      set(value) {
        accessor.setReservedNum(value);
      }
    }
  },
  methods: {
    toSearch() {
      if (this.reservedNum === '') {
        this.message = '予約番号を入力してください。';
      } else {
        var that = this;
        var url = Vue.prototype.$API_URL + 'Change/GetReservedInfo';
        const data = JSON.stringify({
          reservedNum: this.reservedNum
        });

        // server側へアクセス
        that.isLoading = true;
        axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
          .then(function (response) {
            if (response.data) {
              if (response.data.resultCode === 'FAILURE') {
                that.isLoading = false;
                that.message = response.data.resultMessage;
                return;
              }
              const info = response.data;
              that.isLoading = false;
              that.$router.push({ path: 'change', query: { resultData: info } });
            } else {
              that.isLoading = false;
              alert('失敗しました。');
            }
          });
      }
    }
  }
});
